export default {
      id: "ic_recherche-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic_recherche-usage",
      toString: function () {
        return this.url;
      }
    }